// module.exports = require('./src');

import pkg from './src';
export default pkg;